export default {
  // 标签页
  loginIpSummary: "登录IP汇总",
  loginIpDetails: "登录IP明细",
  deviceDetails: "设备明细",

  // 搜索
  ipLocationPlaceholder: "请输入IP地理位置",
  reset: "重置",
  query: "查询",

  // 数据统计
  totalData: "共计{count}条数据",

  // 加载
  loading: "拼命加载中",

  // 表格列 - 登录IP汇总/明细
  ipAddress: "ip地址",
  ipLocation: "IP地理位置",
  loginCount: "登录次数",
  recentLoginTime: "最近登录时间",
  loginTime: "登录时间",
  loginMethod: "登录方式",
  port: "端口",

  // 表格列 - 设备明细
  deviceName: "设备名",
  deviceId: "Device ID (UUID)",
  client: "客户端",
  imei: "IMEI",
  mac: "MAC",

  // 空状态
  noIpData: "当前调证文件中未解析到IP数据",
  noDeviceData: "当前调证文件中未解析到登陆设备数据",

  // 下载
  downloadDetails: "下载数据明细",
  downloadFileName: "数据明细",
};
